<template>
  <div>
    <v-treeview v-bind="$attrs" v-on="$listeners">
       <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

        <!-- Pass on all scoped slots -->
        <template
        v-for="slot in Object.keys($scopedSlots)"
        :slot="slot"
        slot-scope="scope"
        ><slot :name="slot" v-bind="scope"
        /></template>
    </v-treeview>
  </div>
</template>

<script>
export default {
    name: 'ATreeView',
}
</script>

<style>

</style>